'use strict'

import moment from 'moment'
import tabelle from '@/services/tabelleService'
import configurazioni from '@/services/configurazioniService'
import { sanitize } from '@/components/helpers'

export const creaElementi = async function (dati, datiDefault, valoriDefault, riferimento, forzaAggiornamento) {
  const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')

  let tabella = await tabelle.getTabella('anagrafica_tabacchi')
  let esistenti = tabella.tabacchi
  let barcode = dati

  let datiModificati = false
  for(let b of barcode) {
    let ee = esistenti.find(x => String(x.codiceFornitore) === String(b.codice))
    if (ee) {
      ee.elencoBarcode = ee.elencoBarcode || []
      if (!ee.elencoBarcode.find(x => x.barcode === b.barcode)) {
        ee.elencoBarcode.push({
          barcode: b.barcode,
          quantita: parseInt(b.quantita || 0)
        })
        const hs = calcolaHash(ee)
        ee.hash = hs
        datiModificati = true
      }
    }
  }
  try {
    if (datiModificati) {
      tabella.impostazioni.ultimaModifica = new Date()
      tabella.impostazioni.ultimaElaborazione = new Date()
      await tabelle.creaRigaTabella(tabella)
    }
  } catch (error) {
    console.log(`creaElementi: ${error}`)
    return []
  }    
}

function calcolaHash(obj) {
  // -----------------------------------------
  // Eliminare dal calcolo eventuali parametri che non devono essere verificati in modifica
  // es.: delete obj.riordino
  // ------------------------------------------
  // delete obj.hash

  const toHash = {
    categoria: obj.categoria,
    codiceFornitore: obj.codiceFornitore,
    denominazione: obj.denominazione,
    prezzoConfezione: obj.prezzoConfezione,
    prezzoKg: obj.prezzoKg,
    prezzoConfezione: obj.prezzoConfezione, 
    tipoConfezione: obj.tipoConfezione,
    costo: obj.costo,
    confezione: obj.confezione || '',
    elencoBarcode: obj.elencoBarcode || []
  }
  const value = JSON.stringify(toHash)
  var hash = 0;
  if (value.length === 0) return hash;
  for (let i = 0; i < value.length; i++)
  {
    const ch = value.charCodeAt(i);
    hash = ((hash << 5) - hash) + ch;
    hash = hash & hash;
  }
  return hash;
}

export const creaElementiCategoria = async function (dati, datiDefault, valoriDefault, riferimento, forzaAggiornamento) {
  const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
  let tabelleImport = _.get(impostazioni, 'ordiniPeriodici.tabelleImport') || []

  let tabelleT = {}
  let esistenti = []
  for (let t of tabelleImport) {
    const tabname = `anagrafica_tabacchi_${t}`
    tabelleT[t] = await tabelle.getTabella(tabname)
    esistenti = esistenti.concat(tabelleT[t].tabacchi)
  }

  let barcode = dati
  let datiModificati = false
  const daModificare = {}
  for(let b of barcode) {
    let ee = esistenti.find(x => String(x.codiceFornitore) === String(b.codice))
    if (ee) {
      const catSan = sanitize(ee.categoria, true)
      ee.elencoBarcode = ee.elencoBarcode || []
      if (!ee.elencoBarcode.find(x => x.barcode === b.barcode)) {
        ee.elencoBarcode.push({
          barcode: b.barcode,
          quantita: parseInt(b.quantita || 0)
        })
        const hs = calcolaHash(ee)
        ee.hash = hs
        datiModificati = true
        daModificare[catSan] = daModificare[catSan] || []
        daModificare[catSan].push(ee)
      }
    }
  }
  try {
    for (let t of tabelleImport) {
      if (daModificare[t]) {
        for (let v of daModificare[t]) {
          let idx = tabelleT[t].tabacchi.findIndex(x => String(x.codiceFornitore) === String(v.codiceFornitore))
          if (idx > -1) {
            let tt = tabelleT[t].tabacchi[idx]
            tt = { ...tt, ...v }
            const hs = calcolaHash(tt)
            tt.hash = hs
            tabelleT[t].tabacchi[idx] = tt
          }
        }
        tabelleT[t].impostazioni.ultimaElaborazione = new Date()

        // const tabname = `anagrafica_tabacchi_${t}`
        await tabelle.creaRigaTabella(tabelleT[t])

      }
    }
    let tabella = await tabelle.getTabella('anagrafica_tabacchi')
    tabella.impostazioni.ultimaElaborazione = new Date()

  } catch (error) {
    console.log(`creaElementiCategoria: ${error}`)
    return []
  }    
}
